var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"contant"},[_vm._m(0),_c('div',{staticClass:"close",on:{"click":_vm.close}},[_vm._v("退出")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logoUnit"},[_c('img',{attrs:{"src":require("../assets/img/cloudLogo.png"),"alt":""}})])
}]

export { render, staticRenderFns }